import React from 'react';
import { Tabs, Tab } from '@mui/material';
import { useGenericSideBarStyles } from 'src/components/AtlasV2Components/AtlasV2Sidebar/AtlasV2Sidebar';

interface Props {
  subtab: 'summary' | 'templates' | 'data' | 'admin';
  setSubtab: (t: 'summary' | 'templates' | 'data' | 'admin') => void;
}

const SidebarTabs: React.FC<Props> = ({ subtab, setSubtab }) => {
  const classes = useGenericSideBarStyles();
  const tabs = [
    { label: 'Summary', value: 'summary' as const },
    { label: 'Agents', value: 'templates' as const },
    // Keep the label as Coverage for UX, but route to the Data Explorer subtab
    { label: 'Coverage', value: 'data' as const },
    // { label: 'Admin', value: 'admin' as const }
  ];
  const selectedIndex = tabs.findIndex((t) => t.value === subtab);
  return (
    <Tabs
      value={selectedIndex === -1 ? false : selectedIndex}
      orientation="vertical"
      TabIndicatorProps={{ style: { display: 'none' } }}
      style={{ marginTop: '12px' }}
      classes={{ root: classes.tabs }}
    >
      {tabs.map((t, idx) => (
        <Tab
          key={t.value}
          label={t.label}
          classes={{ root: classes.tab }}
          onClick={() => {
            setSubtab(t.value);
            if (t.value === 'summary') {
              window.dispatchEvent(new CustomEvent('shelf:go-summary'));
            }
          }}
          value={idx}
        />
      ))}
    </Tabs>
  );
};

export default SidebarTabs;


